import React, { useCallback, useEffect, useMemo } from "react";
import { useHistory } from "react-router";

import EnvService from "../../../services/env.service";
import RequestService from "../../../services/request.service";
import UrlService from "../../../services/url.service";

import LoadingPage from "../../../components/LoadingPage";

const LOGIN_CHAVEJ_ENDPOINT = "login/pj/chavej";

function LoginPJChaveJ() {
  const history = useHistory();
  const errorsToRedirect = useMemo(() => ["71000", "78000", "74000"], []);

  const goToRegisterMachine = useCallback(
    (e) => {
      try {
        const errorCode = e.response?.data?.error?.errorCode;
        if (errorCode === "75000") {
          history.push("/oauth/register-machine");
        } else if (errorCode && errorsToRedirect.includes(errorCode)) {
          history.push({
            pathname: "/authn/error",
            state: {
              error: e.response.data.error.error,
              providencia: e.response.data.error.providencia,
            },
          });
        } else {
          history.push("/error");
        }
      } catch (err) {
        console.error(err);
      }
    },
    [history, errorsToRedirect]
  );

  const callServiceLoginPJChaveJ = useCallback(async () => {
    console.log("Iniciando login");
    const { REACT_APP_GRAFENO_ROUTE_URL } = EnvService.getEnv();
    try {
      console.log(
        "Variavel REACT_APP_GRAFENO_ROUTE_URL" + REACT_APP_GRAFENO_ROUTE_URL
      );
      const mciPj = UrlService.getQueryString("mciPj");
      const chaveJ = UrlService.getQueryString("chaveJ");
      const codTipo = UrlService.getQueryString("codTipo");
      const jwsToken = UrlService.getQueryString("jwsToken");
      const redirectAppUrl = UrlService.getQueryString("redirect_app_url");

      const queryParams = UrlService.getQueryParamsFromObject({
        mciPj,
        codTipo,
        chaveJ,
        jwsToken,
      });
      await RequestService.post(
        `${REACT_APP_GRAFENO_ROUTE_URL}/${LOGIN_CHAVEJ_ENDPOINT}?${queryParams}&redirect_app_url=${redirectAppUrl}`,
        {}, 
        {},
        120000
      );
      console.log("Redirect to ", redirectAppUrl);
      window.location = redirectAppUrl;
    } catch (e) {
      console.error(e);
      goToRegisterMachine(e);
    }
  }, [goToRegisterMachine]);

  const loadUserGcs = useCallback(async () => {
    try {
      callServiceLoginPJChaveJ();
    } catch (e) {
      console.error(e);
    }
  }, [callServiceLoginPJChaveJ]);

  useEffect(loadUserGcs, [loadUserGcs]);

  return <LoadingPage />;
}

export default LoginPJChaveJ;
